import Axios from "axios"

const state = {
	show: false,
	loading: false,
	versions: {
		show: false,
		loading: false,
		character: {
			id: '',
			version: '',
		},
	},
	error: false,
	errorMessage: '',
}

const getters = {

}

const actions = {
	show({ commit }) {
		commit('show')
	},
	hide({ commit }) {
		commit('hide')
	},
	load({ dispatch }, payload) {
		var uri = `https://data.character.gallery/characters/${payload}`

		if(payload['version']){
			uri = `https://data.character.gallery/characters/${payload['character']}/versions/${payload['version']}`
		}else if(payload['character']){
			uri = `https://data.character.gallery/characters/${payload['character']}`
		}

		Axios.get(uri)
		.then( response => {
			dispatch('setCharacter',{
				'id': response.data.data.id,
				'version': response.data.data.version,
			})
			dispatch('loadCharacter', response.data.data.data, {root: true})
		})
		.finally( () => {
			dispatch('hide')
		})
	},
	recover({ dispatch }, payload) {
		Axios.post(`https://data.character.gallery/characters/${payload['character']}/versions/${payload['version']}/restore`)
		.then( () => {
			dispatch('load', payload)
		})
		.finally( () => {
			dispatch('hide')
		})
	},
	delete({dispatch}, payload) {
		return new Promise( (resolve, reject) => {
			if(confirm(`Are you sure you want to delete the character ${payload.name}?`)){
				dispatch('setLoading', true)
				Axios.delete(`https://data.character.gallery/characters/${payload.id}`)
				.then(() => {
					resolve()
				})
				.finally(() => {
					dispatch('setLoading',false)
				})
			}else{
				dispatch('setLoading',false)
				reject()
			}
		})
		
	},
	setLoading({ commit }, value) {
		commit('setLoading',value)
	},
	showVersions({ commit }) {
		commit('showVersions')
	},
	hideVersions({ commit }) {
		commit('hideVersions')
	},
	setVersionsLoading({ commit }, value) {
		commit('setVersionsLoading',value)
	},
	setCharacter({ commit }, value) {
		commit('setCharacter',value)
	},
	setError({ commit }, payload) {
		commit('setError', payload)
	},
	clearError({ commit }, payload) {
		commit('clearError', payload)
	}
}

const mutations = {
	show (state) {
		state.show = true
	},
	hide (state) {
		state.show = false
	},
	setLoading (state, value) {
		state.loading = value
	},
	showVersions (state) {
		state.versions.show = true
	},
	hideVersions (state) {
		state.versions.show = false
	},
	setVersionsLoading (state, value) {
		state.versions.loading = value
	},
	setCharacter (state, payload) {
		/*eslint-disable-next-line no-console*/
		console.log(payload)
		state.versions.character.id = payload.id
		state.versions.character.version = payload.version||state.versions.character.version
	},
	setError (state, payload) {
		state[payload.module].error = true
		state[payload.module].errorMessage = payload.message
	},
	clearError (state, payload) {
		state[payload.module].error = false
		state[payload.module].errorMessage = ''
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}